export default "__VITE_ASSET__CRW9DLb4__"